import {Button} from "react-bootstrap";
import React from "react";

type Props = {
    itemValue: string;
    onClick: () => void;
    ariaLabel?: string;
};

const ButtonQuantity: React.FC<Props> = ({onClick, itemValue, ariaLabel}) => (
    <Button
        className="m-1 d-flex p-0 btnQuantity"
        style={{
            height: "27px",
            width: "27px",
            borderRadius: "27px",
            justifyContent: "center",
        }}
        variant="outline-secondary"
        onClick={onClick}
        aria-label={ariaLabel}
    >
        <b>{itemValue}</b>
    </Button>
);

export default ButtonQuantity;
